import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

export interface DetailItem {
  title: string;
  value: number;
  visible?: boolean;
  titleClass?: string;
}

@customElement("cost-summery")
export class CostSummeryCompany extends LitElement {
  @property({ type: String }) title = "Förarens kostnad";
  @property({ type: Number }) totalCost = 0;
  @property({ type: String }) subtitle = "Förmånsvärde + drivmedel";
  @property({ type: Boolean }) showDetails = false;
  @property({ type: Array }) detailItems: DetailItem[] = [];
  @property({ type: String }) info = "";

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div class="border border-neutral-on-shadow bg-white-shadow">
        <div class="px-6 py-4">
          <h3 class="preamble">${this.title}</h3>
          <div class="mt-2">
            <div class="h3">${this.totalCost.toLocaleString("sv-SE")} kr</div>
            <div class="small italic text-price mt-1">${this.subtitle}</div>
          </div>
        </div>

        <div class="px-6 py-4 flex items-center justify-between">
          <details class="w-full py-4">
            <summary class="flex justify-end items-center cursor-pointer">
              <span class="open italic text-price font-light mr-4"
                >Visa detaljer</span
              >
              <span class="close italic text-price font-light mr-4"
                >Dölj detaljer</span
              >
              <div>
                <span class="open">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <mask id="path-1-inside-1_1908_17987" fill="white">
                      <path
                        d="M11.5 12.5H6V11.5H11.5V6H12.5V11.5H18V12.5H12.5V18H11.5V12.5Z"
                      />
                    </mask>
                    <path
                      d="M11.5 12.5H6V11.5H11.5V6H12.5V11.5H18V12.5H12.5V18H11.5V12.5Z"
                      fill="#3B3838"
                    />
                  </svg>
                </span>
                <span class="close">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path d="M18 12.5H6V11.5H18V12.5Z" fill="#3B3838" />
                  </svg>
                </span>
              </div>
            </summary>
            <div>
              <div class="py-4">
                <ul class="list-none ml-0 flex flex-col">
                  ${this.detailItems.map(
                    (item) => html`
                      <li
                        ?hidden=${item.visible === false}
                        class="flex justify-between border-b border-neutral-shadow mt-2"
                      >
                        <span
                          class=${`p ${item.titleClass ?? ""}`.trim()}
                          >${item.title}:</span
                        >
                        <span
                          class=${`p ${item.titleClass ?? ""}`.trim()}
                          >${item.value.toLocaleString("sv-SE")} kr</span
                        >
                      </li>
                    `,
                  )}
                </ul>
              </div>
              <span class="small italic text-price mt-1"> ${this.info} </span>
            </div>
          </details>
        </div>
      </div>
    `;
  }
}
